import Vue from "vue";
class PasswordRecoveryServico {
  SolicitarRecuperacao(viewModel) {
    return Vue.prototype.$http({
      url: "password-recovery/request",
      data: viewModel,
      method: "POST"
    });
  }

  ValidarToken(token) {
    return Vue.prototype.$http({
      url: "password-recovery/validate/" + token,
      method: "GET"
    });
  }

  RedefinirSenha(viewModel) {
    return Vue.prototype.$http({
      url: "password-recovery/reset",
      data: viewModel,
      method: "POST"
    });
  }
}

export default new PasswordRecoveryServico();
